/* NovaLiving — interacciones propias (prefijo mt-) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var capas = Array.prototype.slice.call(document.querySelectorAll('[data-mt-parallax]'));
    if (!capas.length || reducido) return;
    var pendiente = false;
    function pinta() {
      pendiente = false;
      var vh = window.innerHeight;
      capas.forEach(function (c) {
        var caja = c.parentElement.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > vh) return;
        var fuerza = parseFloat(c.getAttribute('data-mt-parallax')) || 0;
        var progreso = (caja.top + caja.height / 2 - vh / 2) / vh;
        c.style.transform = 'translate3d(0,' + (progreso * fuerza * -1).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(pinta); }
    }, { passive: true });
    pinta();
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      var grandes = g.querySelectorAll('.mt-pdp__principal img');
      var minis = g.querySelectorAll('.mt-pdp__mini');
      if (!grandes.length) return;
      var actual = 0;
      function ir(i) {
        actual = (i + grandes.length) % grandes.length;
        grandes.forEach(function (im, k) { im.classList.toggle('is-activa', k === actual); });
        minis.forEach(function (m, k) { m.classList.toggle('is-activa', k === actual); });
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      var prev = g.querySelector('[data-mt-prev]');
      var next = g.querySelector('[data-mt-next]');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var x0 = null;
      var marco = g.querySelector('.mt-pdp__principal');
      marco.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      marco.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  function dinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var conComas = valor.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (formato || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, conComas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100));
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var formato = raiz.getAttribute('data-mt-moneda');
      var inputId = raiz.querySelector('input[name="id"]');
      var precio = raiz.querySelector('[data-mt-precio]');
      var tachado = raiz.querySelector('[data-mt-tachado]');
      var ahorro = raiz.querySelector('[data-mt-ahorro]');
      var boton = raiz.querySelector('[data-mt-anadir]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';
      function actualiza() {
        var elegidos = [];
        raiz.querySelectorAll('.mt-opcion').forEach(function (fs) {
          var marcado = fs.querySelector('input:checked');
          elegidos.push(marcado ? marcado.value : null);
          var etiqueta = fs.querySelector('legend span');
          if (etiqueta && marcado) etiqueta.textContent = marcado.value;
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidos[i]; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
          return;
        }
        inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price, formato);
        if (tachado) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          tachado.textContent = hay ? dinero(v.compare_at_price, formato) : '';
          tachado.hidden = !hay;
          if (ahorro) {
            ahorro.hidden = !hay;
            if (hay) ahorro.textContent = ahorro.getAttribute('data-plantilla').replace('[%]', Math.round((1 - v.price / v.compare_at_price) * 100) + '%');
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (window.history && window.history.replaceState && raiz.hasAttribute('data-mt-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      raiz.querySelectorAll('.mt-opcion input').forEach(function (inp) { inp.addEventListener('change', actualiza); });
    });
  }

  function initCantidad() {
    document.querySelectorAll('.mt-cantidad').forEach(function (c) {
      var inp = c.querySelector('input');
      c.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(inp.value, 10) || 1;
          v += b.hasAttribute('data-mas') ? 1 : -1;
          inp.value = Math.max(1, v);
        });
      });
    });
  }

  function initBarra() {
    var barra = document.querySelector('.mt-barra');
    var objetivo = document.querySelector('[data-mt-anadir]');
    if (!barra || !objetivo || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (e) {
      var fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      barra.classList.toggle('is-visible', fuera);
    }).observe(objetivo);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () { objetivo.click(); });
  }

  function arranca() {
    initReveal();
    initParallax();
    initGaleria();
    initVariantes();
    initCantidad();
    initBarra();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
  document.addEventListener('shopify:section:load', function () { initReveal(); initGaleria(); initVariantes(); initCantidad(); });
})();
